<script setup lang="ts">
import UserInfoStep from '~/components/modals/CTA/UserInfoStep.vue';

const modalsStore = useModalsStore();
const activeStep = ref<keyof typeof stepMap>('userInfo');

const SuccessStep = defineAsyncComponent(() => import('~/components/modals/steps/Success.vue'));

const stepMap = {
    userInfo: UserInfoStep,
    success: SuccessStep,
} as const;
const activeComponent = computed(() => stepMap[activeStep.value]);

function handleOnClose() {
    modalsStore.closeModal('CTA');
    activeStep.value = 'userInfo';
};
</script>

<template>
    <ModalsBase 
        :isOpen="modalsStore.modals.CTA.isOpen"
        closeOnClickOutside
        @close="handleOnClose"
    >
        <template #head>
            <div 
                class="w-full h-full flex flex-col justify-center items-center 
                    bg-linear-to-b from-primary-100 to-primary-50"
            >
                <img
                    src="/img/new/cloud/01.webp"
                    class="absolute top-2 left-18 mix-blend-screen"
                    alt="نواتل"
                />
                <img
                    src="/img/new/cloud/02.webp"
                    class="absolute -top-2 right-18 mix-blend-screen w-75"
                    alt="نواتل"
                />
                <Icon 
                    name="nava-icon:navatel-bold" 
                    class="relative z-1 w-14! h-14! md:w-18! md:h-18! text-primary-600" 
                />
                <span class="text-primary-600 text-[1.5rem] md:text-[1.8125rem] font-extrabold relative z-1">نواتل</span>
                <p class="text-body1-bold text-gray-500 mt-2 max-w-50 lg:max-w-full text-center hidden lg:block">
                    نواتل ابزاری قدرتمند برای ساده کردن کسب‌و‌کار شما
                </p>
            </div>
        </template>

        <component 
            :is="activeComponent"
            modalType="CTA"
            successMsg="اطلاعات شما با موفقیت ارسال شد"
            @nextStep="(e: keyof typeof stepMap) => activeStep = e"
            @done="handleOnClose"
        />
    </ModalsBase>
</template>